'use client'

import { lazy, Suspense } from 'react'

const FreshdeskWidget = lazy(() => import('../freshdesk/FreshdeskWidget'))

const Intercom = lazy(() =>
  import('@/src/domains/intercom/components/Intercom').then((res) => ({
    default: res.Intercom,
  })),
)

const SupportWidget = () => {
  const enableIntercom = process.env.NEXT_PUBLIC_ENABLE_INTERCOM === 'true'

  const WidgetComponent = enableIntercom ? Intercom : FreshdeskWidget

  return (
    <Suspense fallback={null}>
      <WidgetComponent />
    </Suspense>
  )
}

export default SupportWidget
